module.exports = __webpack_public_path__ + "img/ieit_systems.aafa01a9.svg";